import { Box, Search as SearchIcon, User, Users } from 'lucide-react';

import { Kbd } from '@components/primitives';

import {
  useCommandMenu,
  useCommandSearch,
} from '@components/features/CommandMenu';
import { Command, RouteCommand } from '@components/features/CommandMenu/types';

import { AdminSearchResult, searchResources } from './queries';

import css from './styles.module.css';

function toCommand(result: AdminSearchResult): Command {
  const base: Pick<RouteCommand, 'type' | 'group' | 'context' | 'searchable'> =
    {
      type: 'route',
      group: 'Search results',
      context: 'global',
      searchable: 'only',
    };

  switch (result.type) {
    case 'team':
      return {
        ...base,
        id: `admin_search_team_${result.uuid}`,
        label: result.name,
        sublabel: result.uuid,
        badge: 'Team',
        icon: <Users />,
        href: `/admin/${result.uuid}`,
      };
    case 'app':
      return {
        ...base,
        id: `admin_search_app_${result.uuid}`,
        label: result.name,
        sublabel: `${result.uuid} · ${result.teamName}`,
        badge: 'App',
        icon: <Box />,
        href: `/admin/${result.teamUuid}/${result.uuid}`,
      };
    case 'user':
      return {
        ...base,
        id: `admin_search_user_${result.id}`,
        label: result.name || result.email,
        sublabel: result.name ? result.email : undefined,
        badge: 'User',
        icon: <User />,
        href: `/admin/users/${result.id}`,
      };
  }
}

export function Search() {
  const { open } = useCommandMenu();

  useCommandSearch(async (query) => {
    const { results } = await searchResources(query);
    return results.map(toCommand);
  });

  return (
    <button className={css.search} onClick={open}>
      <SearchIcon />
      <span className={css.label}>Search...</span>

      <Kbd keys={['meta', 'K']} />
    </button>
  );
}
